import { Type } from "../sso"

import { makeBaseWidgetComponent } from "./make_component"

export const AccountsWidget = makeBaseWidgetComponent(Type.AccountsWidget)
export const BudgetsWidget = makeBaseWidgetComponent(Type.BudgetsWidget)
export const ConnectionsWidget = makeBaseWidgetComponent(Type.ConnectionsWidget)
export const DebtsWidget = makeBaseWidgetComponent(Type.DebtsWidget)
export const FinstrongWidget = makeBaseWidgetComponent(Type.FinstrongWidget)
export const GoalsWidget = makeBaseWidgetComponent(Type.GoalsWidget)
export const HelpWidget = makeBaseWidgetComponent(Type.HelpWidget)
export const MasterWidget = makeBaseWidgetComponent(Type.MasterWidget)
export const MiniBudgetsWidget = makeBaseWidgetComponent(Type.MiniBudgetsWidget)
export const MiniFinstrongWidget = makeBaseWidgetComponent(Type.MiniFinstrongWidget)
export const MiniSpendingWidget = makeBaseWidgetComponent(Type.MiniSpendingWidget)
export const SettingsWidget = makeBaseWidgetComponent(Type.SettingsWidget)
export const SpendingWidget = makeBaseWidgetComponent(Type.SpendingWidget)
export const TransactionsWidget = makeBaseWidgetComponent(Type.TransactionsWidget)
export const TrendsWidget = makeBaseWidgetComponent(Type.TrendsWidget)
